import { BodyPartType } from "@rmh/defs";

// Regions that are not lateralized — their enum value has no Left_/Right_
// prefix, so the whole value is the translation key.
const SINGLE_SIDE_BODY_PARTS: BodyPartType[] = [
  BodyPartType.Neck,
  BodyPartType.UpperBack,
  BodyPartType.LowerBack,
  BodyPartType.Buttocks,
];

export type RegionLabelOptions = {
  translateRegion: (key: string) => string;
  leftLabel: string;
  rightLabel: string;
  fallback: string;
};

// "Left_Knee" -> "Left Knee"; "Lower_Back" -> "Lower Back".
export const formatBodyRegionLabel = (
  bodyPart: BodyPartType | null | undefined,
  opts: RegionLabelOptions
): string => {
  if (!bodyPart) return opts.fallback;

  if (SINGLE_SIDE_BODY_PARTS.includes(bodyPart)) {
    return opts.translateRegion(bodyPart);
  }

  const [side, ...rest] = bodyPart.split("_");
  const regionKey = rest.join("_");
  const sideLabel = side === "Left" ? opts.leftLabel : opts.rightLabel;
  return `${sideLabel} ${opts.translateRegion(regionKey)}`;
};
